import { hostsConfig } from '@openeducation/oe-it-services';
import type { Environment } from '@openeducation/oe-it-services';
import { CurrentClass } from '@openeducation/oe-it-shared-types';
import axios from 'axios';

import {
  ActiveClassCurrentClass,
  ActiveClass,
} from '../../interfaces/active-class';

export default abstract class ActiveClassesDao {
  static async getActiveClasses(env: Environment, teacherId?: number) {
    const url = hostsConfig[env].liveclassServiceUrl;
    const { data } = await axios.get<ActiveClassCurrentClass>(
      `${url}/v1/monitor/liveclasses/${teacherId}`
    );

    return data;
  }
  static async getActiveClassStatus(env: Environment) {
    const url = hostsConfig[env].liveclassServiceUrl;
    const { data } = await axios.get(
      `${url}/v1/liveclasses/cancellations/today`
    );

    return data;
  }
  static async enableLiveClasses(env: Environment, teacherId?: number) {
    const url = hostsConfig[env].liveclassServiceUrl;

    const { data } = await axios.delete(
      `${url}/v1/liveclasses/cancellations/today?teacherId=${teacherId}`
    );

    return data;
  }
  static async disableLiveClasses(env: Environment, teacherId?: number) {
    const url = hostsConfig[env].liveclassServiceUrl;

    const { data } = await axios.put(
      `${url}/v1/liveclasses/cancellations/today?teacherId=${teacherId}`
    );

    return data;
  }
  static async reassignTeacher(
    env: Environment,
    teacherId?: number,
    originalTeacherId?: number,
    classroomId?: number
  ) {
    const url = hostsConfig[env].liveclassServiceUrl;

    const { data } = await axios.put(
      `${url}/v1/liveclasses/classroom/${classroomId}/teacher/${originalTeacherId}`,
      `${teacherId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return data;
  }
  static async getRejoinClasses(env: Environment, teacherId?: number) {
    const url = hostsConfig[env].liveclassServiceUrl;
    const { data } = await axios.get<ActiveClass[]>(
      `${url}/v1/monitor/liveclasses/${teacherId}/rejoins`
    );

    return data;
  }
  static async getCurrentClass(env: Environment, classroomId?: number) {
    const url = hostsConfig[env].liveclassServiceUrl;
    const { data } = await axios.get<CurrentClass>(
      `${url}/v1/liveclasses/classrooms?classroomId=${classroomId}`
    );

    return data;
  }

  static async updateClassStatus(
    env: Environment,
    classroomId: string,
    status: string
  ) {
    const url = hostsConfig[env].liveclassServiceUrl;

    const { data } = await axios.put(
      `${url}/v1/liveclasses/${classroomId}?status=${status}`,
      null,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return data;
  }
}
